// extracted by mini-css-extract-plugin
export default {"container":"SubIssuesListView-module__container--UgTu_"};